---
ID: 66d80edf89048aba1b50e5e9
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "9CzHK1jhA4",
    "type": "text",
    "html": "<p>The&nbsp;<b>Accordion block</b>&nbsp;is a dynamic and interactive way to present content in your documentation. It allows you to organize information into&nbsp;<b>collapsible sections</b>, making it easier for users to navigate and find what they need—without overwhelming them with too much text at once.</p>"
  },
  {
    "id": "5n24zL_H4r",
    "type": "callout",
    "variant": "note",
    "html": "<p>Use this feature to create concise, collapsible sections in your documentation.</p>"
  },
  {
    "id": "PJVQUfr75r",
    "type": "text",
    "html": "<h2 id=\"structure-of-an-accordion-item\"><b>Structure of an Accordion Item</b></h2><p>Each accordion item consists of two main components:</p><ul><li><b>Title</b>: A clear, concise text title that indicates the topic or subject of the accordion item. This title serves as a clickable header that users can interact with to expand or collapse the content.</li><li><b>Body</b>: The body of the accordion item is fully formatable, allowing you to use various&nbsp;<b><u><a href=\"https://docs.easypagego.com/editor/text-formatting/\" target=\"_blank\" rel=\"noopener noreferrer\">text formatting features</a></u></b>, such as lists, links, and other rich content. This flexibility ensures that your accordion items are&nbsp;<b>informative and engaging</b>, making it easy to present complex information in a structured way.</li></ul>"
  },
  {
    "id": "AdL5EP3waW",
    "type": "accordion",
    "multiple": false,
    "items": [
      {
        "id": "oq85uTuKdl",
        "title": "How to Add an Accordion",
        "html": "<ol><li>Navigate to the \"Insert Element\" menu.</li><li>Select \"Accordion\" from the list.</li><li>Add a title and format the body content with text, images, or links.</li></ol>"
      }
    ]
  },
  {
    "id": "mVTeA-Ni7L",
    "type": "text",
    "html": "<h2 id=\"multiple-items-accordion\"><b>Multiple items Accordion</b></h2><p>You can easily add new accordion items by selecting the menu within the accordion. The&nbsp;<b>\"Add Accordion Item\"</b>&nbsp;option lets you place another item within the same accordion group, enabling you to expand your content without cluttering the page. This feature is particularly useful for&nbsp;<b>organizing related information</b>&nbsp;under a single topic, providing a clean and structured layout.</p>"
  },
  {
    "id": "5tLBHE06q_",
    "type": "callout",
    "variant": "success",
    "html": "<p>By hovering over or selecting an accordion item, you can control its position within the group using the edit icon on the right. Rearranging items is as easy as dragging them to their new position.</p>"
  },
  {
    "id": "wAGumkMJvL",
    "type": "text",
    "html": "<h2 id=\"accordion-modes\"><b>Accordion Modes</b></h2><p>Once your accordion contains more than one item, you can customize its behavior with two modes:</p><h3 id=\"open-one-at-a-time\">Open One at a Time</h3><p>Selecting this option ensures that only&nbsp;<b>one accordion item</b>&nbsp;can be open at a time. When a user expands a new item, any previously opened item will automatically collapse. This mode is ideal for guiding users through a&nbsp;<b>linear flow of information</b>, ensuring they focus on one section at a time.</p>"
  },
  {
    "id": "qJ_asJPPya",
    "type": "accordion",
    "multiple": false,
    "items": [
      {
        "id": "sb0hqdZqDH",
        "title": "Either this is expanded",
        "html": "<p>Try to click on the other one.</p>"
      },
      {
        "id": "16jb53v9pU",
        "title": "Or this one",
        "html": "<p>The first one&nbsp;<b>closed on its own</b>.</p>"
      }
    ]
  },
  {
    "id": "beT0gUeKGe",
    "type": "text",
    "html": "<h3 id=\"allow-multiple-open\">Allow Multiple Open</h3><p>This option enables users to expand&nbsp;<b>multiple accordion items</b>&nbsp;simultaneously. It's perfect for situations where users may need to view several sections of content at once, providing them with more&nbsp;<b>flexibility and control</b>&nbsp;over the information.</p>"
  },
  {
    "id": "yMHn93s6-s",
    "type": "accordion",
    "multiple": false,
    "items": [
      {
        "id": "XO-FYTO0K3",
        "title": "You can expand this",
        "html": "<p>Try to click on the next one.</p>"
      },
      {
        "id": "AVW9_ekthp",
        "title": "Or you can expand that",
        "html": "<p>You can still see the body of the first one unless you close it manually.</p>"
      },
      {
        "id": "0-MkJuDwLQ",
        "title": "We act independently of each other",
        "html": "<p>Hello there!</p>"
      }
    ]
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}